import { useAuth } from "./auth";

/** Cadastrar e editar parceiro é decisão comercial: só ADMIN e OWNER. A tela de Cadastros continua
 *  aberta pra quem tem `partners.manage` (recepção lista, desativa, convida) — o que some é o botão
 *  de criar e a edição dos campos. Espelha o `roleProcedure("ADMIN")` que a API exige em
 *  `partner.create/update` e `prosthesis.lab.create/update`. */
export function usePodeEditarParceiro(): boolean {
  const { user } = useAuth();
  const papel = user?.activeOrganization?.role;
  return papel === "OWNER" || papel === "PARTNER" || papel === "ADMIN";
}
